import { FilterModel } from './filter.model';

export class ProductSearchModel {
  filterModel: FilterModel;
  count: number;
  totalCount: number;
  pageNumber: number;
  totalPages: number;
  showInactive: boolean;
  results: any[];
  pageSize: number;

  constructor() {
    this.filterModel = new FilterModel();
    this.count = 0;
    this.totalCount = 0;
    this.pageNumber = 1;
    this.totalPages = 0;
    this.pageSize = 100;
    this.showInactive = false;
    this.results = new Array();
  }
}
